(function() {
    'use strict';
    angular.module('wbUtilities').directive('plaidSelect', ['$timeout', '$interpolate', 'PlaidService', function ($timeout, $interpolate, PlaidService) {
        return {
            restrict: 'E',
            templateUrl: '/common/src/app/directives/plaid/plaid.tpl.html',
            scope: {
                plaidOpenHandler: '&',
                plaidOtherHandler: '&'
            },
            link: function (scope, element, attrs, ctrls, transclude) {

                scope.plaidData = {
                    init: false,
                    searching: false,
                    bankImageLoaded: {},
                    plaidBankList: [],
                    searchBank: ""
                };

                scope.$watch('plaidData.searchBank', function(term) {
                    if (!term) {
                        setDefaultInstitutions();
                    } else {
                        scope.plaidData.searching = true;
                        PlaidService.retrieveSearchInstitutions(term).then(function(institutions) {
                            scope.plaidData.plaidBankList = institutions;
                            scope.plaidData.bankImageLoaded = {};
                        }).finally(function() {
                            scope.plaidData.searching = false;
                        });
                    }
                    console.log(term);
                });

                function setDefaultInstitutions() {
                    PlaidService.retrieveDefaultInstitutions().then(function(institutions) {
                        scope.plaidData.init = true;
                        scope.plaidData.plaidBankList = institutions;
                    });
                }

                /**
                 * Handle what to do once a bank account is clicked
                 * @param institutionId
                 */
                scope.openPlaid = function(institutionId) {
                    scope.plaidOpenHandler()(institutionId);
                };

                /**
                 *  Handle what to do when "other" bank account is selected
                 */
                scope.otherHandler = function(bankName) {
                    scope.plaidOtherHandler()(bankName);
                };

                $(element).on("keydown", "[role=listitem]", function(event) {
                    if (event.which === 13) {
                        $(this).click();
                    }
                });

            }
        };
    }]);
})();
